export default __webpack_public_path__ + "static/media/courses6.fdca6e0e.svg";